export var NOTIFICATION_TITLE_KEY = 'view.autoSearch.notification.title';
export var NOTIFICATION_DESCRIPTION_KEY = 'view.autoSearch.notification.description';
